import { type ReactNode } from "react";
import { createPortal } from "react-dom";

import { useOverlayShell } from "./useOverlayShell";

/**
 * Centered glass overlay for short confirms (archive, remove). Long forms use GlassDrawer.
 */
export function GlassModal({
  open,
  onClose,
  ariaLabel,
  children,
  busy = false,
  size = "md",
}: {
  open: boolean;
  onClose: () => void;
  ariaLabel: string;
  children: ReactNode;
  busy?: boolean;
  size?: "sm" | "md" | "lg";
}) {
  const { panelRef } = useOverlayShell(open, busy, onClose);

  if (!open) return null;

  return createPortal(
    <div
      className="glass-modal"
      role="presentation"
      onClick={(event) => {
        if (busy || event.target !== event.currentTarget) return;
        onClose();
      }}
    >
      <div
        ref={panelRef}
        className={`glass-modal__panel glass-modal__panel--${size}`}
        role="dialog"
        aria-modal="true"
        aria-label={ariaLabel}
        tabIndex={-1}
      >
        <div className="glass-modal__shine" aria-hidden="true" />
        <div className="glass-modal__body">{children}</div>
      </div>
    </div>,
    document.body,
  );
}
